import * as Sentry from "@sentry/browser";

const doConsoleLogSentryConfig = new URL(location.href).searchParams.get('debug-sentry') !== null;
const tracesSampleRate = window.SENTRY_TRACES_SAMPLE_RATE;
const replaysSessionSampleRate = window.SENTRY_REPLAYS_SESSION_SAMPLE_RATE;
const replaysOnErrorSampleRate = window.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE;

const sentryConfig = {
  dsn: window.SENTRY_DSN,
  environment: window.APP_ENV,
  release: "topgeschenken-webshop@" + (window.APP_VERSION),
  integrations: [
    new Sentry.BrowserTracing(),
    new Sentry.Replay(),
  ],
  tracesSampleRate,
  replaysSessionSampleRate,
  replaysOnErrorSampleRate,
  denyUrls: [
    // Ignore errors from third-party analytics/tracking scripts
    /cdn\.mouseflow\.com/i,
  ],
  beforeSend(event) {
    try {
      const isFromGTM = (
        event.request?.url?.includes('gtm.js') || 
        event.exception?.values?.some(e => 
          e.stacktrace?.frames?.some(f => 
            f.filename?.includes('gtm.js')
          )
        )
      );
      
      if (isFromGTM) {
        return null;
      }
    } catch (e) {
      return event;
    }
    
    return event;
  },
};

if (doConsoleLogSentryConfig) {
  console.info(sentryConfig)
}

Sentry.init(sentryConfig);
